import { createPayloadAction } from 'redux/helpers';
import { StandardAction } from 'redux/types';
import { IMessage } from 'types/messages';

export default class ChatMessagesAction {
  static ACTION_TYPES = {
    SET_CHAT_MESSAGES: 'chatMessages/SET_CHAT_MESSAGES',
    RESET_CHAT_MESSAGES: 'chatMessages/RESET_CHAT_MESSAGES',
  };

  static setChatMessages(
    target: string,
    messages: IMessage[],
  ): StandardAction<{ messages: IMessage[]; target: string }> {
    return createPayloadAction(this.ACTION_TYPES.SET_CHAT_MESSAGES, { target, messages });
  }

  static resetChatMessages(): StandardAction {
    return createPayloadAction(this.ACTION_TYPES.RESET_CHAT_MESSAGES);
  }
}
